// import React from "react";
// import { Pagination } from "react-bootstrap";
// import "./Commonpagination.scss";
// import styles from "./Pagination.module.scss";
// import { LeftArrow, RightArrow } from "../../../assets/icons/svgicons";

// const Commonpagination = ({
//   className,
//   currentPage,
//   totalPages,
//   handlePageChange,
//   position
// }) => {
//   let active = currentPage;
//   let items = [];

//   for (let number = 1; number <= totalPages; number++) {
//     items.push(
//       <Pagination.Item
//         key={number}
//         active={number === active}
//         value={number}
//         onClick={() => handlePageChange(number)}
//       >
//         {number}
//       </Pagination.Item>
//     );
//   }

//   const handleNextPrev = (type) => {
//     if (type === "next") {
//       if (active !== totalPages) {
//         handlePageChange(active + 1);
//       }
//     } else {
//       if (active !== 1) {
//         handlePageChange(active - 1);
//       }
//     }
//   };

//   return (
//     <>
//       <div className={`${className || ""} ${styles.pagination} justify-content-${position || "center"
//         }`}>
//         <Pagination >
//           <Pagination.Prev onClick={() => handleNextPrev("prev")}>
//             <LeftArrow />
//           </Pagination.Prev>
//           {items}
//           <Pagination.Next onClick={() => handleNextPrev("next")}>
//             <RightArrow />
//           </Pagination.Next>
//         </Pagination>
//       </div>
//     </>
//   );
// };

// export default Commonpagination;

import React from "react";
import { Pagination } from "react-bootstrap";
import "./Commonpagination.scss";
// import styles from "./Pagination.module.scss";

const Commonpagination = ({
  totalPages,
  currentPage,
  handlePageChange,
  className,
  position,
}) => {
  const MAX_PAGES = 4;

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= MAX_PAGES) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }
    } else {
      const leftOffset = Math.floor(MAX_PAGES / 2);
      let startPage = currentPage - leftOffset;
      let endPage = currentPage + leftOffset - 1;

      if (startPage < 1) {
        startPage = 1;
        endPage = MAX_PAGES;
      } else if (endPage > totalPages) {
        endPage = totalPages;
        startPage = totalPages - MAX_PAGES + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }

      // if (startPage > 1) {
      //   pageNumbers.unshift(
      //     <Pagination.Ellipsis key="start-ellipsis" disabled />
      //   );
      //   pageNumbers.unshift(
      //     <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
      //       {1}
      //     </Pagination.Item>
      //   );
      // }

      if (endPage < totalPages) {
        pageNumbers.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
        pageNumbers.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      }
    }

    return pageNumbers;
  };

  return (
    <>
      <div className={`common_pagination ${className} pagination justify-content-${position || "center"}`}>
        <Pagination>
          <Pagination.First
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {getPageNumbers()}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </>
  );
};

export default Commonpagination;
